import { css } from 'linaria';

export const image = css`
  position: relative;
  z-index: -1;
  background-position: center;
  background-size: cover;
  transition: transform 0.3s;
  width: auto;
  height: 152px;
`;

export const container = css`
  overflow: hidden;

  @media (pointer: fine) {
    &:hover {
      .${image} {
        transform: scale(1.1);
      }
    }
  }
`;
